import { orderStatus } from '@/constants/orderStatus';
import { calcDelay } from '@/utils';
import DelayOrder from './DelayOrder';
const SHARE_ORDER = true;
/**
 * 지연출력주문 관련 설명 aka 공유지연시간
 * https://www.notion.so/barogohq/89a6427e89634e84b9454a8927d4105b#48f51246881444e1bd6a08ffcd97285d
 */
/**
 * 지연출력주문 컨트롤러
 */
export class ShareDelaySecondController {
    // 지연 없이 바로 처리할 주문 상태들
    directCallStatus = [
        orderStatus.ALLOCATED.code,
        orderStatus.IMMEDIATE_ALLOCATE.code,
        orderStatus.PICKUP_ARRIVED.code,
        orderStatus.PICKUP_FINISHED.code,
        orderStatus.DROP_FINISHED.code,
        orderStatus.CANCELED.code,
    ];
    // DelayOrder[]
    items = new Map();
    get(orderId) {
        return this.items.get(orderId);
    }
    call(orderId) {
        const { callback, orderData, } = this.get(orderId);
        callback(orderData, SHARE_ORDER);
    }
    add(delayOrder) {
        const { orderId, } = delayOrder.orderData;
        this.items.set(orderId, delayOrder);
    }
    update(orderId, newData) {
        const order = this.get(orderId);
        Object.assign(order, newData);
    }
    delete(orderId) {
        const order = this.get(orderId);
        if (!order) {
            return false;
        }
        clearTimeout(order.timerId);
        this.items.delete(orderId);
        return true;
    }
    /**
     * 타이머 시작
     * @param orderId
     * @param intervalId
     * @returns
     */
    _startTimer(orderId, intervalId) {
        return setTimeout(() => {
            this.call(orderId);
            this.delete(orderId);
        }, intervalId);
    }
    /**
     * 바로 처리할 상태 리스트
     * @param statusCode
     * @returns
     */
    isDirectCallStatus(statusCode) {
        return this.directCallStatus.includes(statusCode);
    }
    /**
     * 추가, 기 등록건이면 업데이트
     * @param delayOrder 지연주문 객체
     * @param callback
     */
    register(delayOrder) {
        if (delayOrder instanceof DelayOrder === false) {
            console.log('[shareDelaySecondController::register] invalid type', delayOrder);
            return;
        }
        const { orderData } = delayOrder;
        const { orderId, orderedAt, agencyShareInfo, } = orderData;
        // 지연 후 추가
        const delaySecond = agencyShareInfo?.shareDelaySecond;
        const interval = calcDelay(orderedAt, delaySecond);
        const timerId = this._startTimer(orderId, interval);
        delayOrder.setTimerId(timerId);
        this.add(delayOrder);
    }
}
export default new ShareDelaySecondController();
